import React from 'react';
import Refinancing from '../layout/Refinancing';

export default function Refinancovani() {
  return (
    <div>
      <Refinancing />
    </div>
  );
}
